import React__default, { useCallback } from 'react';
import { s as selectOptionQuery } from '../SelectList/SelectList-CKJ1ZhdU.js';
import { u as useDropdownIsMobile } from './DropdownIsMobileContext-DM1QP5jf.js';
import { D as DesktopContainer } from './DropdownDesktopContainer-CDRxVOrb.js';
import { M as MobileContainer } from './DropdownMobileContainer-BkGOXLSJ.js';
import { f as focusFirstElement } from '../LocalModules/storm-ui-utils/dist/esm/focusableElements/focusFirstElement-C1TqGpwr-LXfVb-eG.js';

const DropdownContainer = ({
  isOpen,
  togglePopoverViewFromPopper,
  secondaryViewCloseButtonLabel,
  children,
  shadowRoot,
  trigger,
  anchorEl,
  preRender,
  postRender,
  selectedValue,
  onChange,
  noWrap,
  focusSelected,
  forceOpen,
  maxHeight,
  openDirection,
  forceDirection,
  popoverRef
}) => {
  const isMobile = useDropdownIsMobile();
  const focusSelectOption = useCallback(containerEl => {
    if (focusSelected) {
      if (containerEl) {
        // focus on the selected item or the first option on the list
        const selectedEl = containerEl.querySelector(`${selectOptionQuery}[aria-selected="true"]`);
        if (selectedEl) {
          selectedEl.focus();
        } else {
          const firstEl = containerEl.querySelector(`${selectOptionQuery}`);
          if (firstEl) {
            firstEl.focus();
          }
        }
      }
    } else {
      focusFirstElement(containerEl);
    }
  }, [focusSelected]);
  if (isMobile) {
    return /*#__PURE__*/React__default.createElement(MobileContainer, {
      isOpen: isOpen,
      onClose: togglePopoverViewFromPopper,
      anchorEl: anchorEl,
      secondaryViewCloseButtonLabel: secondaryViewCloseButtonLabel,
      preRender: preRender,
      postRender: postRender,
      trigger: trigger,
      selectedValue: selectedValue,
      onChange: onChange,
      focusSelectOption: focusSelectOption
    }, children);
  }
  return /*#__PURE__*/React__default.createElement(DesktopContainer, {
    isOpen: isOpen,
    onClose: togglePopoverViewFromPopper,
    shadowRoot: shadowRoot,
    trigger: trigger,
    preRender: preRender,
    selectedValue: selectedValue,
    onChange: onChange,
    noWrap: noWrap,
    postRender: postRender,
    focusSelectOption: focusSelectOption,
    anchorEl: anchorEl,
    forceOpen: forceOpen,
    maxHeight: maxHeight,
    popoverRef: popoverRef,
    openDirection: openDirection,
    forceDirection: forceDirection
  }, children);
};

export { DropdownContainer as D };
//# sourceMappingURL=DropdownContainer-BEEPq5JF.js.map
